import {library} from '@fortawesome/fontawesome-svg-core';
import {
  faCircle,
  faArchive,
  faComment,
  faEyeSlash,
  faEye,
  faStepBackward,
  faStepForward,
  faBars,
  faUserFriends,
  faBookmark,
  faHome,
  faAngleDown,
  faCogs,
  faChartArea,
  faEdit,
  faFileDownload,
  faFileUpload,
  faFile,
  faUndo,
  faPrint,
  faBook,
  faTimes,
  faSignOutAlt,
  faArrowsAltH,
  faSave,
  faBan,
  faSearch,
  faPlus,
  faCheck,
  faExchangeAlt,
  faTrash,
  faArrowRight,
  faExclamation,
  faUserPlus,
  faPaperclip,
  faComments,
  faCommentDots,
  faCaretDown,
  faCaretUp,
  faTachometerAlt,
  faAsterisk,
  faMailBulk,
  faBell,
  faUserTie,
  faSpinner,
  faFilter,
  faUpload,
  faUserTimes,
  faPlusCircle,
  faChevronCircleUp,
  faSync,
  faCheckCircle,
  faKey,
  faUserLock,
  faSyringe,
  faHouseUser,
  faUserShield,
  faHistory,
  faClipboard,
  faShieldAlt,
  faRecycle,
  faFileAlt,
  faRightToBracket,
  faPencil,
  faShip,
  faMessage,
  faFileLines,
  faEraser,
} from '@fortawesome/free-solid-svg-icons';

export const IconConfig = {
  config() {
    library.add(
        faCircle, faArchive, faComment, faRightToBracket,
        faEyeSlash, faEye, faStepBackward, faStepForward,
        faBars, faUserFriends, faBookmark, faHome,
        faAngleDown, faCogs, faChartArea,
        faEdit, faBookmark, faFileDownload, faFileUpload, faFile, faUndo, faPrint,
        faBook, faTimes, faSignOutAlt,
        faArrowsAltH, faArrowsAltH, faSave, faBan, faSearch,
        faPlus, faCheck, faExchangeAlt, faTrash,
        faArrowRight, faExclamation, faComments, faCommentDots, faCaretDown,
        faCaretUp, faUserPlus, faPaperclip,
        faTachometerAlt, faAsterisk, faMailBulk, faBell, faUserTie,
        faSpinner, faFilter,
        faUpload, faUserTimes, faPlusCircle, faChevronCircleUp, faSync,
        faCheckCircle, faKey, faUserLock,
        faSyringe, faHouseUser, faUserShield, faHistory, faClipboard, faShieldAlt,
        faRecycle, faFileAlt, faPencil, faShip, faMessage, faFileLines, faEraser,
    );
  },
};

export default {IconConfig};
